export default __webpack_public_path__ + "static/media/sv11_en_rudl_a2.dd6ffa83.mp3";